import { useEffect } from 'react';
import EVENTS from '@/utils/Constants/Events';
import { useRecipeFilterContext } from '@/context/recipeFilter';

// api
import apiFacetsAndResults from '@/api/get/recipe/facetsAndResults';

export default () => {
  const [state, { setFilters }] = useRecipeFilterContext();
  const { query, hasLoadMore, updateHistory, isFirstLoad } = state;
  useEffect(() => {
    if (!query.value) return;
    const successCB = ({ filters, html }) => {
      if (filters) setFilters(filters);
      if (updateHistory) {
        window.history.pushState(state, null, query.url);
      }
      if (!isFirstLoad)
        DLG.EVE.emit(EVENTS.RECIPE.RESULTS.UPDATE, {
          html,
        });
    };

    apiFacetsAndResults({
      query: query.value,
      hasLoadMore,
      successCB,
    });
  }, [query]);
};
